/** Depth-first collection of every `field` leaf, in document order, with its path. */
export function flattenStructureLeaves(nodes) {
    const out = [];
    const walk = (list, prefix) => {
        for (const node of list) {
            const path = [...prefix, node.name];
            if (node.type === "field") {
                out.push({ node, path: path.join("/") });
            }
            else if (node.children) {
                walk(node.children, path);
            }
        }
    };
    walk(nodes, []);
    return out;
}
/**
 * The columns-as-projection invariant: the flat `columns` every consumer reads
 * is ALWAYS the field leaves of the structure tree, in document order. Callers
 * persist this alongside `structure` so legacy reads keep working unchanged.
 */
export function deriveColumnsFromStructure(nodes) {
    return flattenStructureLeaves(nodes).map((leaf, i) => {
        const col = { name: leaf.node.name, order: i + 1 };
        if (leaf.node.dataType !== undefined)
            col.dataType = leaf.node.dataType;
        if (leaf.node.format !== undefined)
            col.format = leaf.node.format;
        if (leaf.node.length !== undefined)
            col.length = leaf.node.length;
        if (leaf.node.position !== undefined)
            col.position = leaf.node.position;
        if (leaf.node.note !== undefined)
            col.note = leaf.node.note;
        if (leaf.node.expression !== undefined)
            col.expression = leaf.node.expression;
        return col;
    });
}
/**
 * Builds a FLAT structure tree (one `field` slot per column) from the columns
 * editor's rows. Used by CSV/fixed-width (and the flat fields of any type) so
 * the format owns the slot contract. Flags default to required:false,
 * allowEmpty:true to match the Slice 1 migration defaults.
 */
export function flatColumnsToStructure(columns) {
    return columns
        .slice()
        .sort((a, b) => a.order - b.order)
        .map((c) => {
        const node = { name: c.name, type: "field" };
        if (c.dataType !== undefined)
            node.dataType = c.dataType;
        if (c.format !== undefined)
            node.format = c.format;
        if (c.length !== undefined)
            node.length = c.length;
        if (c.position !== undefined)
            node.position = c.position;
        if (c.note !== undefined)
            node.note = c.note;
        if (c.expression !== undefined)
            node.expression = c.expression;
        node.required = c.required ?? false;
        node.allowEmpty = c.allowEmpty ?? true;
        return node;
    });
}
//# sourceMappingURL=export-structure.js.map